import { controls } from "../../controls";

const rp909 = {
  label: "Period Wise Overdue",
  pageLabel: "Period Wise Overdue",
  starting: true,
  url: "rp909",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({tab: "filter",label: "Six Years Ago",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",name:"six_years_ago_date",isRequired:true,width:"col-sm-2"}),
    
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-3 "}),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form:[],

  history: {
    perPage: 10,
    reportHeader: "Period Wise Overdue Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Name of Head",
        accessor: "name_of_head_code",
        width: 100,
        rwidth: 50
      },
      {
        Header: "Ovdrdues",
        columns: [
          {
            Header: "Within 1 Year",
            accessor: "within_one_year",
            type:"currency",
            rwidth:"*"
          },
          {
            Header: "Above 1 Year but below 2 Years",
            accessor: "above_one_year_below_two_year_name",
            type:"currency",
            rwidth:"*"
          },
          {
            Header: "Above 2 Year but below 3 Years",
            accessor: "above_two_year_below_three_year_name",
            type:"currency",
            rwidth:"*"
          },
          {
            Header: "Above 3 Year but below 4 Years",
            accessor: "above_three_year_below_four_year_name",
            type:"currency",
            rwidth:"*"
          },
          {
            Header: "Above 4 Year but below 5 Years",
            accessor: "above_four_year_below_five_year_name",
            type:"currency",
            rwidth:"*"
          },
          {
            Header: "Above 5 Year but below 6 Years",
            accessor: "above_five_year_below_six_year_name",
            type:"currency",
            rwidth:"*"
          },
          {
            Header: "Above 6 Years",
            accessor: "above_six years_name",
            type:"currency",
            rwidth:"*"
          },
          {
            Header: "Total",
            accessor: "total_name",
            type:"currency",
            rwidth:"*"
          },
        ]
      },
            
    ]
  }
};

export default rp909;
